import React, { useState, useEffect } from "react";
import "./style.scss";

interface TabProps {
  name: string;
  children: any;
  icon?: string;
}

interface TabHeaderProps {
  index: number;
  title: string;
  onClick: Function;
  isSelected: boolean;
  icon?: string;
}

export const TabContainer = ({ children, style, headerStyle, icon }: any) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  let tabToRender = null;
  const tabHeaders: any[] = [];
  React.Children.map(children, (child, index) => {
    if (index === selectedIndex) {
      tabToRender = React.cloneElement(child);
    }
    tabHeaders.push({ ...child.props });
  });

  const headerClassName = headerStyle
    ? "e-tab-" + headerStyle + "-header"
    : "e-tab-header";

  const onTabClick = (index: number) => {
    setSelectedIndex(index);
  };

  return (
    <div className="e-tab-container" style={style}>
      <div className={headerClassName}>
        {tabHeaders.map((header, index) => (
          <TabHeader
            onClick={onTabClick}
            key={index}
            index={index}
            title={header.name}
            icon={header.icon}
            isSelected={index === selectedIndex}
          />
        ))}
      </div>

      {tabToRender !== null && tabToRender}
    </div>
  );
};

export const Tab = ({ children }: TabProps) => {
  return <div className="e-tab-area">{children}</div>;
};

export const TabHeader = ({
  onClick,
  title,
  index,
  icon,
  isSelected,
}: TabHeaderProps) => {
  return (
    <div
      className={
        "e-tab-header-item" + (isSelected ? " e-tab-selected-header-item" : "")
      }
      onClick={() => onClick(index)}
    >
      {icon && <img src={icon} width="18px" height="18px" />}
      {title}
    </div>
  );
};
